<template>
  <el-row type="flex" justify="center">
    <el-col :span="20">
      <div class="ad-banner bottom">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5507837965607182" data-ad-slot="8721174888" data-ad-format="auto" data-full-width-responsive="true"></ins>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ad-bottom',
  mounted() {
    let adsbygoogle = window.adsbygoogle;
    if (!adsbygoogle) {
      adsbygoogle = [];
    }
    adsbygoogle.push({});
    window.adsbygoogle = adsbygoogle;
  }
}
</script>

<style scoped>
.ad-banner {
  line-height: 7em;
  max-height: 7em;
  text-align: center;
  vertical-align: middle;
}
.ad-banner.bottom {
  margin-top: 2em;
}
</style>